module.exports = __webpack_public_path__ + "static/media/socha.a3554a87.jpg";